import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {LOAI_DON_THUOC, LOAI_FORM, tabKeys, TT_DON_KINH} from "types/enums";
import {glassKiotService} from "api";
import Notification from "components/common/notification/notification";
import {LOAI_DON_KINH} from "types/enums/glass";
type State = {
  idBill: string | number;
  detailBill: any;
  statusBill: TT_DON_KINH;
  typeForm: LOAI_FORM;
  patientRef: any;
  glassRef: any;
  storeId: any;
  searchForm: any;
  activeTabPresciption: string;
  typePrescription: LOAI_DON_KINH;
  showHoanTra: boolean;
  salePrescription: any;
  listPatient: any[];
};

const initialState: State = {
  idBill: null,
  statusBill: null,
  typeForm: null,
  detailBill: null,
  patientRef: null,
  searchForm: null,
  showHoanTra: false,
  activeTabPresciption: tabKeys.GLASSES.LIST_1,
  typePrescription: null,
  salePrescription: null,
  glassRef: null,
  storeId: null,
  listPatient: [],
};

export const glassKiotSlice = createSlice({
  name: "glassKiot",
  initialState: initialState,
  reducers: {
    setStatusBill: (state = initialState, action: PayloadAction<any>) => {
      return {
        ...state,
        statusBill: action.payload,
      };
    },
    setTypeForm: (state = initialState, action: PayloadAction<any>) => {
      return {
        ...state,
        typeForm: action.payload,
      };
    },

    setIdBill: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        idBill: actions.payload,
      };
    },
    setDetailBill: (state = initialState, action: PayloadAction<any>) => {
      return {...state, detailBill: action.payload};
    },
    setPatientRef: (state = initialState, action: PayloadAction<any>) => {
      return {
        ...state,
        patientRef: action.payload,
      };
    },
    setGlassRef: (state = initialState, action: PayloadAction<any>) => {
      return {
        ...state,
        glassRef: action.payload,
      };
    },
    setStoreId: (state = initialState, action: PayloadAction<any>) => {
      return {
        ...state,
        storeId: action.payload,
      };
    },
    setSearchForm: (state = initialState, action: PayloadAction<any>) => {
      return {...state, searchForm: action.payload};
    },
    setTypePrescription: (state = initialState, action: PayloadAction<any>) => {
      return {...state, typePrescription: action.payload};
    },
    setActiveTabPresciption: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {...state, activeTabPresciption: action.payload};
    },
    setSalePrescription: (state = initialState, action: PayloadAction<any>) => {
      return {...state, salePrescription: action.payload};
    },
    setListPatient: (state = initialState, action: PayloadAction<any>) => {
      return {...state, listPatient: action.payload};
    },
    setExpandRef: (state = initialState, action: PayloadAction<any>) => {
      return {...state, expandRef: action.payload};
    },
    setShowHoanTra: (state = initialState, action: PayloadAction<any>) => {
      return {...state, showHoanTra: action.payload};
    },
  },
});

export const getDetailBillAPI = id => {
  return async dispatch => {
    try {
      const res = (await glassKiotService.getDetailBill(id)) || null;
      dispatch(setDetailBill(res));
    } catch (error) {
      dispatch(setDetailBill(null));
      Notification("error", "Đã có lỗi xảy ra khi lấy chi tiết đơn");
    }
  };
};
export const updateStatusBillAPI = params => {
  return async dispatch => {
    try {
      const res = (await glassKiotService.updateStatusBill(params)) || null;
      dispatch(setDetailBill(res));
      Notification("success", "Đã cập nhật trạng thái đơn thành công");
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi cập nhật trạng thái đơn");
    }
  };
};
export const getListPatientAPI = name => {
  return async dispatch => {
    try {
      const listPatient = (await glassKiotService.getListPatient(name)) || [];
      dispatch(setListPatient(listPatient));
    } catch (error) {}
  };
};

export const {
  setIdBill,
  setTypeForm,
  setStatusBill,
  setDetailBill,
  setPatientRef,
  setGlassRef,
  setStoreId,
  setSearchForm,
  setActiveTabPresciption,
  setTypePrescription,
  setSalePrescription,
  setShowHoanTra,
  setExpandRef,
  setListPatient,
} = glassKiotSlice.actions;
export default glassKiotSlice.reducer;
